export default {
  paymentInfo1: '개인',
  __typename: 'CustomCheckout'
};
